import React from 'react';
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar } from 'recharts';

type DataPoint = { label: string; valor: number };

type Props = {
  data: DataPoint[];
  height?: number;
  barName?: string;
  barColor?: string;
  xTickAngle?: number;
};

const BarChartWithMinHeight: React.FC<Props> = ({
  data,
  height = 350,
  barName = 'Quantidade/Valor',
  barColor = '#10b981',
  xTickAngle = -25,
}) => {
  return (
    <div style={{ width: '100%', minHeight: height }}>
      <ResponsiveContainer height={height}>
        <BarChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 60 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="label" angle={xTickAngle} textAnchor="end" interval={0} height={60} />
          <YAxis />
          <Tooltip formatter={(value: any) => Number(value)} />
          <Legend />
          <Bar dataKey="valor" name={barName} fill={barColor} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChartWithMinHeight;